// Plain line icons drawn like chalk strokes; every one sits next to its label.
const P = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

export const Icons = {
  board: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}>
      <rect x="3" y="4" width="18" height="12" />
      <path d="M7 20l2-4M17 20l-2-4M7 9h6M7 12h9" />
    </svg>
  ),
  schedule: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}>
      <rect x="3" y="5" width="18" height="16" />
      <path d="M3 10h18M8 3v4M16 3v4" />
    </svg>
  ),
  materials: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}>
      <path d="M6 3h9l4 4v14H6z" />
      <path d="M15 3v4h4M9 12h7M9 16h7" />
    </svg>
  ),
  practice: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}>
      <path d="M4 20l4-1L19 8l-3-3L5 16z" />
      <path d="M14 7l3 3" />
    </svg>
  ),
  // Play is your slime's page, so its mark is your slime
  play: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}>
      <path d="M3.5 19.5C2.6 12.5 7 6.5 12.5 6.8c5.6.3 9 6.4 7.8 12.7z" />
      <path d="M12.5 6.8c-.4-1.8.6-3.3 2.2-3.8" />
      <circle cx="9.5" cy="13.5" r=".9" fill="currentColor" />
      <circle cx="15" cy="13.5" r=".9" fill="currentColor" />
    </svg>
  ),
  tv: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}>
      <rect x="3" y="5" width="18" height="12" />
      <path d="M10 8.5v5l4.5-2.5z" />
      <path d="M8 21h8" />
    </svg>
  ),
  out: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P} width="18" height="18">
      <path d="M14 4h6v6M20 4l-9 9M18 14v6H4V6h6" />
    </svg>
  ),
};

// the chalk slime that heads the "dagashiya is open" note
export function SlimeMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 40 30" width="40" height="30" aria-hidden="true">
      <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M6 24 C 4 12 14 4 22 6 C 32 8 36 18 32 24 Z" />
        <circle cx="15" cy="16" r="1.4" fill="currentColor" />
        <circle cx="24" cy="16" r="1.4" fill="currentColor" />
      </g>
    </svg>
  );
}
